import React, { createContext, useContext, useEffect, useState } from "react"
import { useAuth } from "services/auth/auth-service-hooks"
import { useMmsService } from "services/mms/context/MmsServiceContext"
import { UserContextType } from "types/user"

type UserContextValues = UserContextType & {
    isAuthenticated: boolean
    isLoading: boolean
}

export const UserContext = createContext<UserContextValues>(
    {} as UserContextValues
)

export const UserContextProvider = ({
    children,
}: {
    children: React.ReactNode
}) => {
    const { profileService } = useMmsService()
    const { useSelfContext } = profileService
    const { isAuthenticated, isLoading } = useAuth()
    const { data: selfProfileData, sendRequest: fetchProfile } =
        useSelfContext()
    const [user, setUser] = useState<UserContextType>({} as UserContextType)

    useEffect(() => {
        if (isAuthenticated) fetchProfile()
        else {
            setUser({} as UserContextType)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated])

    useEffect(() => {
        if (selfProfileData) setUser(selfProfileData as UserContextType)
    }, [selfProfileData])

    return (
        <UserContext.Provider value={{ ...user, isAuthenticated, isLoading }}>
            {children}
        </UserContext.Provider>
    )
}

// eslint-disable-next-line
export const useUserContext = () => useContext(UserContext)
